var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5134 14.0349C18.5382 13.4617 17.2833 13.7878 16.71 14.763L16.6667 14.8317L15.6859 16.53C15.6512 16.6047 15.6101 16.6762 15.5629 16.7437L15.5527 16.7609C15.3127 17.0995 14.9207 17.3214 14.4751 17.3288H18.9755C19.5812 17.3288 20.0179 17.1312 20.2557 16.811L20.3637 16.5953C20.758 15.6636 20.4097 14.5612 19.5134 14.0349Z",
    fill: "url(#paint0_linear_3334_33135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 17.3287H9.82176C9.37533 17.3212 8.98191 17.0977 8.74219 16.7568L9.07186 17.3287L10.9475 20.577C11.2624 21.1229 11.6703 21.406 12.083 21.4335C12.1265 21.4341 12.1703 21.4341 12.2139 21.4335C12.9055 21.4241 13.5924 21.2682 14.1204 20.9637L18.925 18.1894C19.4335 17.8959 19.8948 17.4057 20.2448 16.8399C20.258 16.8184 20.2707 16.797 20.284 16.7758C20.0531 17.1176 19.6042 17.3287 18.9759 17.3287Z",
    fill: "url(#paint1_linear_3334_33135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9472 20.5772L9.07157 17.3288L8.73226 16.7405C8.68698 16.6758 8.64736 16.6072 8.61385 16.5356L6.46297 12.8104C6.39519 12.72 6.33694 12.6222 6.29279 12.5158C6.22506 12.3524 6.1903 12.1772 6.1905 12.0003C6.1905 11.8171 6.22699 11.643 6.29279 11.4841L5.99517 12.0003L4.12006 15.2483C3.8051 15.7925 3.76357 16.2866 3.94476 16.6574C3.96649 16.697 3.98935 16.736 4.01261 16.7753C4.36623 17.3686 4.84452 17.885 5.37166 18.1896L10.1761 20.9639C10.7041 21.2684 11.3911 21.4242 12.0828 21.4336C11.67 21.4061 11.2621 21.1231 10.9472 20.5772V20.5772Z",
    fill: "url(#paint2_linear_3334_33135)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07168 6.67139H5.32118C4.69304 6.67139 4.24475 6.8814 4.01385 7.22289C3.98997 7.2629 3.9668 7.30333 3.94435 7.34416C3.60766 7.94678 3.3999 8.61786 3.3999 9.22616V14.7741C3.3999 15.3826 3.60798 16.0546 3.94491 16.6574C3.76372 16.2866 3.80525 15.7925 4.12021 15.2484L5.99532 12.0003L6.29294 11.4842C6.33705 11.3785 6.39535 11.2801 6.46312 11.1899L8.61489 7.46346L8.73189 7.25994L8.74285 7.24071C8.97669 6.9091 9.35547 6.68949 9.78767 6.67139H9.07168V6.67139Z",
    fill: "url(#paint3_linear_3334_33135)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2248 6.67132L13.3493 3.42264C13.0355 2.8788 12.6288 2.59561 12.2176 2.56683C12.1712 2.56594 12.1248 2.56594 12.0785 2.56683C11.3884 2.57666 10.7029 2.73221 10.1761 3.03628L5.37159 5.81034C4.84501 6.11482 4.36758 6.63007 4.01367 7.22281C4.24457 6.88133 4.69285 6.67132 5.321 6.67132H14.5097C14.9408 6.68942 15.3182 6.9079 15.552 7.23781L15.2248 6.67132V6.67132Z",
    fill: "url(#paint4_linear_3334_33135)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.083 21.4336C12.1265 21.4363 12.1703 21.4363 12.2139 21.4336C12.1703 21.4343 12.1265 21.4343 12.083 21.4336Z",
    fill: "url(#paint5_linear_3334_33135)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94434 7.34417C3.96679 7.30334 3.98996 7.26291 4.01384 7.2229C3.98754 7.26144 3.9643 7.30199 3.94434 7.34417V7.34417Z",
    fill: "url(#paint6_linear_3334_33135)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01268 16.7751C3.98942 16.7362 3.9668 16.6969 3.94482 16.6572C3.96483 16.698 3.9875 16.7374 4.01268 16.7751Z",
    fill: "url(#paint7_linear_3334_33135)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2177 2.56684C12.1714 2.56366 12.1249 2.56366 12.0786 2.56684C12.125 2.56591 12.1713 2.56591 12.2177 2.56684V2.56684Z",
    fill: "url(#paint8_linear_3334_33135)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1835 7.06314C19.8415 6.53801 19.4039 6.08686 18.9249 5.81041L14.1203 3.03635C13.5934 2.73228 12.9082 2.57677 12.2178 2.56689C12.629 2.59568 13.0357 2.87883 13.3495 3.42271L15.225 6.67138L16.7119 9.26962C17.2873 10.2495 18.5481 10.5771 19.5275 10.0012C20.5069 9.42625 20.8343 8.16558 20.2591 7.18591L20.1835 7.06314V7.06314Z",
    fill: "url(#paint9_linear_3334_33135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_33135",
    x1: 17.4998,
    y1: 17.3288,
    x2: 17.4998,
    y2: 13.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9B51C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3334_33135",
    x1: 8.74219,
    y1: 19.0954,
    x2: 20.2841,
    y2: 19.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9B51C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3334_33135",
    x1: 3.83739,
    y1: 16.4589,
    x2: 12.0827,
    y2: 16.4589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9B51C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3334_33135",
    x1: 1.597,
    y1: 14.3095,
    x2: 9.51138,
    y2: 6.39517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3334_33135",
    x1: 4.01375,
    y1: 4.902,
    x2: 15.552,
    y2: 4.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3334_33135",
    x1: 12.083,
    y1: 21.4346,
    x2: 12.2139,
    y2: 21.4346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3334_33135",
    x1: 3.94434,
    y1: 7.28354,
    x2: 4.01384,
    y2: 7.28354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3334_33135",
    x1: 3.94486,
    y1: 16.7162,
    x2: 4.01268,
    y2: 16.7162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3334_33135",
    x1: 12.0786,
    y1: 2.56563,
    x2: 12.2177,
    y2: 2.56563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3334_33135",
    x1: 12.2178,
    y1: 6.42609,
    x2: 20.5427,
    y2: 6.42609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951F28"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheq);
export default __webpack_public_path__ + "static/media/cheq.5cc8fc05980fe321b5b1dae53107017b.svg";
export { ForwardRef as ReactComponent };